exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-warehouse-buttons[data-v-3aee4b24] {\n  margin-right: -50px;\n  margin-bottom: -40px;\n  margin-left: -50px;\n}\n.select-warehouse-buttons .modal-button[data-v-3aee4b24] {\n    width: 50%;\n}\n.select-warehouse-text[data-v-3aee4b24] {\n  margin-bottom: 20px;\n  text-align: center;\n}\n.select-warehouse-text .p[data-v-3aee4b24] {\n    width: 100%;\n    text-align: center;\n    text-justify: auto;\n}\n", ""]);

// exports
